export { default as ValueAggregationWidget } from "./value_aggregation_widget";
export { default as WidgetEditValueAggregation } from "./value_aggregation_widget_form";

import * as ValueAggregationWidgetFactory from "./value_aggregation_widget_factory";

export { ValueAggregationWidgetFactory };
